import React from 'react'

const PackCommonCard = ({ img, title, value }) => {
    return (
        <div>
            <div className='update-section pack'>
                <div className='update-wraper'>
                    <div className='update-header'>
                        <img src={img} alt="name" />
                    </div>
                    <h2 className='pack-details'>{title}</h2>
                    <span >{value}</span>

                </div>

            </div>
         
        </div>
    )
}

export default PackCommonCard